import { render, staticRenderFns } from "./ChamaileonEmailTemplateEditor.vue?vue&type=template&id=25031694&scoped=true&"
import script from "./ChamaileonEmailTemplateEditor.vue?vue&type=script&lang=ts&"
export * from "./ChamaileonEmailTemplateEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ChamaileonEmailTemplateEditor.vue?vue&type=style&index=0&id=25031694&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25031694",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VBtn,VCardActions,VCardText,VCardTitle,VCol,VContainer,VRow,VSpacer})
